import { TargetSelector, getSettingValueSelector } from "@client/selectors";
import { createSelector } from "reselect";
import { localStateSelector } from "../../selectors";

export const makeItemsSelector = () => {
  const itemsSelector = createSelector([localStateSelector], (ls) => ls.cart.variantItems);
  const productVariantIdSelector = getSettingValueSelector(TargetSelector.Entity, "productVariant");

  return createSelector([itemsSelector, productVariantIdSelector], (items, productVariantId) => {
    const item = items.find((x) => x.id === productVariantId);
    return item ? [item] : items;
  });
};
